var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_05a62f392561a5db0b5bcd312d7d91da",
    "data-name": "05a62f392561a5db0b5bcd312d7d91da",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.498,
    height: 75.52,
    viewBox: "0 0 75.498 75.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M31.2,12.234l13.7,4.553.885-1.4-4.083-4.3s2.917-6.646,4.132-9.517A1.125,1.125,0,0,0,44.845,0C41-.1,36.327,3.672,34.1,5.7c-.605.555-1.172,1.151-1.73,1.754A5.769,5.769,0,0,1,28.649,9.5a1.671,1.671,0,0,0-1.183.489.653.653,0,0,0,.253,1.087L27.3,12.737a.749.749,0,1,0,1.452.366l.392-1.552.634.211-.355,1.415a.75.75,0,1,0,1.455.366l.327-1.31Z",
    transform: "translate(15.62 0)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M0,0H4.666V9.5H0Z",
    transform: "translate(45.726 21.601) rotate(-68.649)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M35.086,18.408a.621.621,0,0,1-.176-.615l1.2-4.544a.624.624,0,0,1,1.208.318l-1.2,4.544a.624.624,0,0,1-1.032.3Zm-2.623-1.025a.621.621,0,0,1-.168-.643l1.406-4.46a.624.624,0,1,1,1.191.376l-1.406,4.459a.624.624,0,0,1-1.022.269Zm-2.309-.9a.623.623,0,0,1-.171-.632l1.326-4.492a.624.624,0,0,1,1.2.354L31.179,16.2a.624.624,0,0,1-1.025.278Z",
    transform: "translate(17.159 6.259)",
    fill: "#b3b3b3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M74.956,15.074S76.5,5.954,72.042,3.532a1.125,1.125,0,0,0-1.576.583L67,12.915l-3.782.714L45.952,6.983a1.183,1.183,0,0,0-1.606,1.038c-.2,3.551-1.231,12.085-6.6,17.693L2.555,59.676A8.1,8.1,0,1,0,14.363,70.752l31.645-37.29a25.516,25.516,0,0,1,3.76-2.727,33.055,33.055,0,0,1,11.445-4.38c1.62-.264,6.892-1.26,8.606-3.3C69.821,23.056,74.4,19.055,74.956,15.074Zm-27.035-.653a.61.61,0,0,1,.81-.341l7.222,3.072a.609.609,0,0,1,.324.8L53.8,23.819a.61.61,0,0,1-.766.34l-7.227-2.534a.613.613,0,0,1-.37-.8l2.483-6.4ZM5.164,69.529a5.364,5.364,0,1,1,6.766-.219,5.366,5.366,0,0,1-6.766.219Z",
    transform: "translate(0.068 1.947)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M38.485,25.054a3.3,3.3,0,0,0-4.811-4.512L6.423,46.673a.846.846,0,0,0,.4,1.428,8.091,8.091,0,0,1,5.868,5.5.847.847,0,0,0,1.452.313L38.485,25.054Z",
    transform: "translate(3.536 11.222)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M0,0H4.062V39.506H0Z",
    transform: "matrix(-0.707, 0.707, -0.707, -0.707, 38.371, 35.493)",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M49.227,62.42,25.193,38.385a3.323,3.323,0,0,1-.92-2.943,3.315,3.315,0,0,0-3.057-3.907l-.415-.024L31.514,20.8l.025.415a3.319,3.319,0,0,0,3.907,3.056,3.331,3.331,0,0,1,2.943.92L62.423,49.225a3.957,3.957,0,0,1,0,5.6l-7.595,7.595a3.955,3.955,0,0,1-5.6,0Z",
    transform: "translate(11.915 11.912)",
    fill: "#3665f3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M53.854,53.853a3.205,3.205,0,0,0,0-4.533L35.107,30.575a3.2,3.2,0,1,0-4.533,4.531L49.32,53.851A3.208,3.208,0,0,0,53.854,53.853Zm-6.6,6.6a3.205,3.205,0,0,0,0-4.533L28.511,37.171a3.205,3.205,0,0,0-4.533,0ZM37.172,23.977a3.205,3.205,0,0,0,0,4.533L55.917,47.255a3.205,3.205,0,0,0,4.533,0Z",
    transform: "translate(13.735 13.733)",
    fill: "#daf1f9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M0,0H15.152V2.232H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 31.136, 41.846)",
    fill: "#daf1f9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M9.049,4.067l1.386,3.495-2.87,2.87L4.069,9.046l0,0L0,2.873,2.872,0Z",
    transform: "translate(0.001)",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsSetting);
export default __webpack_public_path__ + "static/media/tools-setting.4c703cde8be8e1959ea146d459754018.svg";
export { ForwardRef as ReactComponent };